"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./WirelessCRP.scss");
var UtilityFunctions_1 = require("../../../../utils/UtilityFunctions");
var utils_1 = require("@idp/ui-components/utils");
var ui_components_1 = require("@idp/ui-components");
var __1 = require("../../..");
var wlsUtils = require("../../../../utils/WirelessUtilFunctions");
var PriceContainerProps_1 = require("@idp/ui-components/components/cards/PriceContainer/PriceContainerProps");
var WirelessCRP = /** @class */ (function (_super) {
    __extends(WirelessCRP, _super);
    function WirelessCRP(props) {
        var _this = _super.call(this, props) || this;
        _this.showEditIcon = _this.showEditIcon.bind(_this);
        _this.getLineName = _this.getLineName.bind(_this);
        _this.getDeviceLineItem = _this.getDeviceLineItem.bind(_this);
        _this.getPlanLineItem = _this.getPlanLineItem.bind(_this);
        return _this;
    }
    WirelessCRP.prototype.render = function () {
        var _a;
        var ctnNumber = this.props.losg && this.props.losg.extraParams && this.props.losg.extraParams.associatedCtn;
        var lineNumber = ctnNumber ? "" + UtilityFunctions_1.formatPhoneNumberWithDot(ctnNumber, true) : '';
        var lineName = this.getLineName(this.props.losg, lineNumber);
        var deviceLineItem = this.getDeviceLineItem(this.props.losg);
        var deviceImgInfo = wlsUtils.getItemImage(deviceLineItem);
        var planLineItem = this.getPlanLineItem(this.props.losg);
        return (React.createElement(React.Fragment, null,
            React.createElement("div", null,
                React.createElement(ui_components_1.Label, { data: { isDecodingRequired: false, text: "" + lineName }, options: { className: styles.linename }, testId: utils_1.default('WRLS', 'CRP', "Device") }),
                React.createElement("span", null, this.showEditIcon(this.props.losg))),
            React.createElement("div", { className: [styles.deviceLineInfo, styles.displayFlex, styles.deviceName].join(' ') },
                React.createElement("div", null, deviceImgInfo && deviceImgInfo.imageUrl &&
                    React.createElement("img", { className: styles.deviceImg, src: deviceImgInfo.imageUrl, alt: deviceImgInfo.imgAltText })),
                React.createElement("div", { className: styles.lineitemnameWidth },
                    React.createElement("div", { className: [styles.lineItemName, styles.lineitemnameWidth].join(' ') },
                        React.createElement("div", null,
                            React.createElement("span", { className: styles.itemname }, deviceLineItem === null || deviceLineItem === void 0 ? void 0 : deviceLineItem.displayName))),
                    React.createElement("div", null,
                        React.createElement("div", { className: styles.container },
                            React.createElement("div", { className: styles.content },
                                React.createElement("span", { className: styles.changeLabel }, "Changed"),
                                React.createElement(ui_components_1.RichText, { testId: utils_1.default('Wireless', 'Changed', 'RatePlan'), data: { isDecodingRequired: false, text: planLineItem === null || planLineItem === void 0 ? void 0 : planLineItem.displayName } })),
                            React.createElement("div", null,
                                React.createElement(ui_components_1.PriceContainer, { testId: utils_1.default('Wireless', 'Changed', 'RatePlan_Price'), data: { billingNote: '/mo.', price: (_a = planLineItem === null || planLineItem === void 0 ? void 0 : planLineItem.price) === null || _a === void 0 ? void 0 : _a.amount }, options: { className: styles.price,
                                        decimalPoints: 2, overrideAccessibility: true,
                                        type: PriceContainerProps_1.PricingType.XSMALL } }))))))));
    };
    WirelessCRP.prototype.showEditIcon = function (losg) {
        var _this = this;
        var _a;
        var subscriberFName = ((_a = losg === null || losg === void 0 ? void 0 : losg.subscriberName) === null || _a === void 0 ? void 0 : _a.firstName) ? losg.subscriberName.firstName : '';
        return (React.createElement(React.Fragment, null, losg.pscEditUrl &&
            React.createElement("div", { className: [styles.editIcon].join(' ') },
                React.createElement(__1.EditAndRemove, { data: {}, options: { ariaLabelEdit: "Edit " + subscriberFName + " Line", hideRemoveLink: true, isIconsMode: true }, events: {
                        onItemEdit: function () {
                            _this.props.events.onEdit('WIRELESS', losg.pscEditUrl, 'Edit Line');
                        },
                    } }))));
    };
    WirelessCRP.prototype.getLineName = function (losg, lineNumber) {
        var _a, _b, _c;
        if (((_a = losg.subscriberName) === null || _a === void 0 ? void 0 : _a.firstName) && lineNumber) {
            return losg.subscriberName.firstName + "'s line - " + lineNumber;
        }
        else if ((_b = losg.subscriberName) === null || _b === void 0 ? void 0 : _b.firstName) {
            return losg.subscriberName.firstName + "'s line";
        }
        else {
            return "" + ((_c = this.props.wlsCMSData) === null || _c === void 0 ? void 0 : _c.lineLabel);
        }
    };
    WirelessCRP.prototype.getDeviceLineItem = function (losg) {
        var lineItems = Object.values(losg === null || losg === void 0 ? void 0 : losg.lineItems);
        var lineItemData = lineItems.filter(function (lineItem) {
            var _a;
            return ((_a = lineItem.itemType) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === 'DEVICE';
        });
        return lineItemData[0];
    };
    WirelessCRP.prototype.getPlanLineItem = function (losg) {
        var lineItems = Object.values(losg === null || losg === void 0 ? void 0 : losg.lineItems);
        var lineItemData = lineItems.filter(function (lineItem) {
            var _a;
            return ((_a = lineItem.itemType) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === 'SHAREDDATAFEATURE';
        });
        return lineItemData[0];
    };
    return WirelessCRP;
}(React.Component));
exports.default = WirelessCRP;
//# sourceMappingURL=WirelessCRP.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CartLob/WirelessCart/WirelessCRP/WirelessCRP.js
// module id = 2349
// module chunks = 8